<template>
  <!-- Component hiển thị thông tin chi tiết 1 gói cước dạng 3 cột -->
  <b-row class="align-items-center mb-2 subscription-plan-item-row no-gutters">
    <!-- Cột 1: Tên gói cước, giá tiền và chu kỳ sử dụng (chiếm 36%) -->
    <b-col class="plan-col-main text-truncate pr-2">
      <div class="font-weight-bold text-truncate plan-name" :title="planName">
        {{ planName }}
      </div>
      <div class="detail-pack text-truncate">
        {{ formatCurrencyAmount(plan.price) }} VND / {{ plan.numberOfDaysUsage }} {{ $t(plan.unitTime + 's') }}
      </div>
    </b-col>

    <!-- Cột 2: Số lượng cuộc họp / tháng và số cuộc họp đồng thời (hoặc nhãn gói Pool) (chiếm 26%) -->
    <b-col class="plan-col-sub px-1">
      <div class="detail-pack text-nowrap">
        <b-icon icon="camera-video" class="mr-1" />
        {{ $t("displayActiveSubMeetingCount", { count: plan.numberOfMeetingsPerMonth }) }}
      </div>
      <!-- Gói cuộc họp đồng thời: hiển thị số CH đồng thời -->
      <div v-if="!isPool" class="detail-pack text-nowrap">
        <b-icon icon="list" class="mr-1" />
        {{ $t("displayActiveSubConcurrentMeetings", { count: plan.numberOfConcurrentMeetings }) }}
      </div>
      <!-- Gói Pool người tham dự: hiển thị phân loại Pool -->
      <div v-else class="detail-pack text-secondary text-nowrap">
        <b-icon icon="layers" class="mr-1" />
        {{ $t("concurrentParticipantPoolOption") }}
      </div>
    </b-col>

    <!-- Cột 3: Số lượng người tham gia (theo CH hoặc theo Pool) và thời lượng tối đa của một cuộc họp (chiếm 38%) -->
    <b-col class="plan-col-extra pl-2">
      <div class="detail-pack text-nowrap">
        <b-icon icon="people" class="mr-1" />
        <span v-if="!isPool">{{ $t("displayActiveSubMaxParticipants", { count: plan.maximumNumberOfParticipantsInMeeting }) }}</span>
        <span v-else>{{ $t("displayActiveSubMaxParticipantsPool", { count: poolParticipants }) }}</span>
      </div>
      <div class="detail-pack text-nowrap">
        <b-icon icon="clock" class="mr-1" />
        {{ $t("displayActiveSubMaxMeetingLength", { count: plan.maximumLengthOfOneMeeting }) }}
      </div>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { formatCurrencyAmount } from "@/service/util";
import { ManagementType } from "@/views/enums/subscriptionAction";

/**
 * Component hiển thị thông tin tóm tắt của một gói cước.
 * Tự động nhận diện loại gói cước:
 * - Gói cước cuộc họp đồng thời (CONCURRENT_MEETING): Hiển thị số CH đồng thời và người / CH.
 * - Gói cước Pool người tham dự (CONCURRENT_PARTICIPANT_POOL): Hiển thị nhãn Pool và giới hạn người tham gia Pool.
 */
@Component
export default class SubscriptionPlanItem extends Vue {
  /** Đối tượng thông tin gói cước truyền từ component cha */
  @Prop({ required: true }) readonly plan!: any;

  /** Lấy tên gói cước an toàn từ thuộc tính name hoặc subscriptionPlanName */
  get planName(): string {
    return this.plan?.name || this.plan?.subscriptionPlanName || "";
  }

  /** Kiểm tra xem gói cước có phải là loại Pool người tham dự hay không */
  get isPool(): boolean {
    return (
      this.plan?.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL
    );
  }

  /** Số lượng người tham dự tối đa trong Pool */
  get poolParticipants(): number {
    return this.plan?.maxParticipantPool ?? 0;
  }

  /** Định dạng số tiền thành chuỗi phân tách dấu chấm (VND) */
  formatCurrencyAmount(val: number) {
    return formatCurrencyAmount(val);
  }
}
</script>

<style lang="scss" scoped>
.subscription-plan-item-row {
  font-size: 11pt !important;
  width: 100%;
}

.plan-col-main {
  flex: 0 0 36%;
  max-width: 36%;
  min-width: 0;
}

.plan-col-sub {
  flex: 0 0 26%;
  max-width: 26%;
  min-width: 0;
}

.plan-col-extra {
  flex: 0 0 38%;
  max-width: 38%;
  min-width: 0;
}

.plan-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.detail-pack {
  font-size: 12px !important;
  white-space: nowrap;
}

@media (max-width: 576px) {
  .plan-col-main,
  .plan-col-sub,
  .plan-col-extra {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 4px;
  }
}
</style>
